import NotFound from "components/404/NotFound";

export const PageDoesNotExist: React.FC = () => <NotFound />;
